import { DEFAULT_DATE_FORMAT, YM_DATE_FORMAT } from "@/constants";
import { useMemo } from "react";
import { format, formatDate } from "date-fns";
import { DefaultValues } from "react-hook-form";
import { ReadClient } from "@/types/client";
import { ReadProject } from "@/types/project";
import { ReadInvoiceSpecification } from "@/types/invoiceSpecification";

interface UseInvoiceSpecificationsFormDefaultValuesProps {
  period?: string;
  project?: ReadProject;
  client?: ReadClient;
  specificationInvoicingCompany?: string;
}

export const useInvoiceSpecificationsFormDefaultValues = ({
  period,
  project,
  client,
  specificationInvoicingCompany,
}: UseInvoiceSpecificationsFormDefaultValuesProps): DefaultValues<ReadInvoiceSpecification> => {
  const currentDate = useMemo(() => new Date(), []);
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const invoicingCompany =
    specificationInvoicingCompany ?? project?.invoicing_company ?? "";

  return useMemo(
    () => ({
      period: period ?? formatDate(currentDate, YM_DATE_FORMAT),
      project_name: project?.name || "",
      invoicing_company: invoicingCompany,
      issued_at: format(currentDate, DEFAULT_DATE_FORMAT),
      po_number: "",
      code: project
        ? `${invoicingCompany}/${project.ref_number}/${year}/${month}`
        : "",
      services_and_goods: project?.services_and_goods || "",
      services_and_goods_code: project?.services_and_goods_code || "",
      services_and_goods_invoice_description:
        project?.services_and_goods_invoice_description || "",
      primary_manager: project?.primary_manager || "",
      primary_manager_id: project?.primary_manager_id || "",
      comment: "",
      client: client?.name || "",
      client_code: client?.code || "",
      client_contact_invoice: client
        ? `${client?.contact_person_invoice || ""} ${client?.email_invoice || ""} ${client?.phone_number_invoice || ""}`
        : "",
    }),
    [period, project, client, invoicingCompany, currentDate, year, month],
  );
};
